<template>
  <div>
  <in-wrapper>
    <in-ibox>
      <div slot="title" class="p-sm m-t-n">
        <b v-if="existingInvoice">Invoice {{ existingInvoice.invoice.InvoiceNumber }}</b>
        <b v-else>New Invoice</b>
        <span v-if="total > 0">
          <button class="btn btn-danger btn-sm pull-right m-l-xs" @click="deleteInvoice"><i class="fa fa-remove"></i> Delete</button>
          <button class="btn btn-primary btn-sm pull-right m-l-xs" @click="createInvoice('AUTHORISED')"><i class="fa fa-upload"></i> Authorise</button>
          <button class="btn btn-primary btn-sm pull-right" @click="createInvoice('DRAFT')"><i class="fa fa-save"></i> Save Draft</button>
        </span>
      </div>
      <div slot="content">
        <div class="row">
          <div class="col-lg-6"></div>
          <div class="col-lg-2">
            <label for="">Client</label>
            <v-select :options="clients" label="name" index="id" v-model="client"></v-select>
          </div>
          <div class="col-lg-2">
            <label for="">Issue Date</label>
            <input class="form-control" type="date" name="" id="" v-model="date">
          </div>
          <div class="col-lg-2">
            <label for="">Due Date</label>
            <input class="form-control" type="date" name="" id="" v-model="dueDate">
          </div>
          <div class="row">
            <div class="col-lg-6"></div>
            <div class="col-lg-2"></div>
            <div class="col-lg-2">
              <label for="">Currency</label>
              <v-select :options="['EUR']"></v-select>
            </div>
            <div class="col-lg-2">
              <label for="">Theme</label>
              <v-select></v-select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="m-t">
            <table class="table invoice-table">
              <thead>
              <tr>
                <th style="width: 300px;">Item</th>
                <th>Description</th>
                <th style="width: 90px;">Quantity</th>
                <th style="width: 90px;">Price</th>
                <th>Account</th>
                <th>Tax Rate</th>
                <th>Department</th>
                <th>Amount</th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <Item
                v-for="(item, i) in itemCount" :key="item + '-' + i"
                :items="items" :accounts="accounts"
                :index="i"
                @itemDelete="deleteItem($event)"
                @itemUpdate="updateItems"
                :ref="'item' + i"
                v-show="invoiceItems[i] !== null"
                :existingInvoice="existingInvoice ? existingInvoice.invoice : null"
              ></Item>
              <tr>
                <td colspan="8">
                  <button class="btn btn-primary btn-xs pull-right" @click="itemCount++; invoiceItems[itemCount] = {}"><i class="fa fa-plus"></i> Add Item</button>
                </td>
              </tr>
              </tbody>
            </table>
            <table class="table invoice-total">
              <tbody>
              <tr>
                <td><b>Sub Total:</b></td>
                <td>{{ subTotal }} {{ invoice.CurrencyCode }}</td>
              </tr>
              <tr>
                <td><b>Tax:</b></td>
                <td>{{ tax }} {{ invoice.CurrencyCode }}</td>
              </tr>
              <tr>
                <td><b>Total:</b></td>
                <td>{{ total }} {{ invoice.CurrencyCode }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </in-ibox>
  </in-wrapper>
  </div>
</template>
<script>
import axios from 'axios'
import Item from './InvoiceItem.vue'

export default {
  name: 'CreateInvoice',
  data () {
    return {
      id: null,
      items: [],
      accounts: [],
      clients: [],
      itemCount: 0,
      invoiceItems: [],
      invoice: {
        currencyCode: 'EUR'
      },
      subTotal: 0,
      total: 0,
      tax: 0,
      client: null,
      date: '',
      dueDate: '',
      existingInvoice: null
    }
  },
  components: {
    Item: Item
  },
  async mounted () {
    this.id = this.$route.params.id || null
    document.title = (this.id ? `Edit invoice` : 'Create Invoice') + ' :: PBN360 by Aphex Media'
    await this.getItems()
    await this.loadClients()
    await this.loadAccounts()
    if (this.id) {
      await this.loadInvoice()
      this.client = this.existingInvoice.client ? this.existingInvoice.client.id : null
      this.date = this.existingInvoice.invoice.DateString ? this.existingInvoice.invoice.DateString.substring(0, 10) : null
      this.dueDate = this.existingInvoice.invoice.DueDateString ? this.existingInvoice.invoice.DueDateString.substring(0, 10) : null
      this.itemCount = this.existingInvoice.invoice.LineItems.length
    } else {
      this.itemCount = 1
    }
  },
  methods: {
    async getItems () {
      let items = await axios.get(`/billing/xero/items`)
      this.items = items.data
    },
    async loadClients () {
      let clients = await axios.get(`/billing/xero/clients`)
      this.clients = clients.data
    },
    async loadAccounts () {
      let accounts = await axios.get(`/billing/xero/accounts`)
      this.accounts = accounts.data
    },
    async updateItems (i) {
      this.invoiceItems[i.index] = {item: i.item, quantity: i.quantity}
      await this.calculateTotals()
    },
    async deleteItem (i) {
      this.invoiceItems[i] = null
      await this.calculateTotals()
    },
    async calculateTotals () {
      this.invoice.SubTotal = this.subTotal = 0
      this.invoice.Total = this.total = 0
      this.invoice.Tax = this.tax = 0
      await this.invoiceItems.forEach(item => {
        if (item && item.item) {
          this.subTotal += item.item.SalesDetails.UnitPrice * item.quantity
          this.total += item.item.SalesDetails.UnitPrice * item.quantity
        }
      })
    },
    async createInvoice (status) {
      await this.calculateTotals()

      const items = []
      this.invoiceItems.forEach(i => {
        if (i.item) {
          console.log('Item: ', i.item)
          if (i.item.LineItemID) {
            items.push({
              Quantity: i.quantity,
              UnitAmount: i.item.SalesDetails.UnitPrice,
              LineItemID: i.item.LineItemID,
              Description: i.item.Description,
              AccountCode: i.item.SalesDetails.AccountCode,
              Tracking: i.item.Tracking,
              ItemCode: i.item.Code
            })
          } else {
            items.push({
              Quantity: i.quantity,
              UnitAmount: i.item.SalesDetails.UnitPrice,
              ItemCode: i.item.Code,
              Description: i.item.Description,
              AccountCode: i.item.SalesDetails.AccountCode,
              Tracking: i.item.Tracking
            })
          }
        }
      })
      try {
        console.log(items)
        if (!this.existingInvoice) {
          await axios.post(`/integrations/xero/invoices`, {
            Type: 'ACCREC',
            Status: status,
            LineItems: items,
            client: this.client,
            Date: this.date,
            DueDate: this.dueDate
          })
          console.log('Creating new!')
        } else {
          console.log('Updating')
          await axios.patch(`/integrations/xero/invoices/${this.existingInvoice.id}`, {
            Type: 'ACCREC',
            Status: status,
            LineItems: items,
            client: this.client,
            Date: this.date,
            DueDate: this.dueDate
          })
        }
        this.$toastr.success('Invoice updated successfully!')
        await this.$router.push(`/admin/billing/invoice/${this.id}`)
      } catch (e) {
        this.$toastr.error(e)
      }
    },
    async loadInvoice () {
      this.existingInvoice = (await axios.get(`/integrations/xero/invoices/${this.id}`)).data
    },
    async deleteInvoice () {
      if (!confirm('Do you really want to delete the invoice?')) {
        return
      }
      try {
        await axios.delete(`/integrations/xero/invoices/${this.id}`)
        this.$toastr.success('Invoice deleted')
        await this.$router.push('/admin/billing/invoices')
      } catch (e) {
        this.$toastr.error('Unable to delete the invoice', e.response.data.error.msg)
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pages/Admin/Billing/Tabs/Billing/CreateInvoice.vue